import React from "react";
import { Link } from "react-router-dom";

const ItemEducation = (props) => {
  // types -> [course,home]
  return (
    <Link
      to={`/Education/content/${props.data.id}/${props.type}`}
      className="item-education"
    >
      <div className="pic">
        <img src={props.data.image} />
      </div>
      <div className="detailes">
        <h4>{props.data.title}</h4>
        <div className="list-tags">
          {props.data.tags.map((item) => (
            <span>{item.name}</span>
          ))}
        </div>
        <div className="row-details">
          <span>{props.data.created_at}</span>
          <span>
            <i className="icon-comment"></i>
            {props.data.comment_count}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ItemEducation;
